import React from "react";
import GoldDivider from "../components/GoldDivider";
import { CONTACT } from "../lib/constants";

export default function Legal() {
  return (
    <div data-testid="legal-page">
      <section className="hero-noir py-20 px-4 md:px-8 text-center">
        <span className="text-xs uppercase tracking-[0.3em] text-[#B8860B]">Légal</span>
        <h1 className="font-display text-4xl md:text-6xl text-white mt-3 mb-4">Mentions légales & CGV</h1>
        <GoldDivider />
      </section>

      <div className="max-w-3xl mx-auto px-4 md:px-8 py-16 space-y-10 text-neutral-600 leading-relaxed">
        <Section title="Éditeur du site">
          <p>Le site MaxiChoix est édité par MaxiChoix, boutique en ligne d'articles pratiques et tendance pour la famille, basée à {CONTACT.city}.</p>
          <p>Email : {CONTACT.email} — Téléphone : {CONTACT.phoneIntl}</p>
        </Section>
        <Section title="Conditions Générales de Vente">
          <p>Les présentes CGV régissent les ventes réalisées sur le site MaxiChoix. Toute commande implique l'acceptation
          pleine et entière de ces conditions.</p>
        </Section>
        <Section title="Prix">
          <p>Les prix sont indiqués en francs CFA (FCFA), toutes taxes comprises. MaxiChoix se réserve le droit de modifier
          ses prix à tout moment, les produits étant facturés au tarif en vigueur au moment de la commande.</p>
        </Section>
        <Section title="Commande & Paiement">
          <p>La commande est validée après confirmation par le client. Les paiements acceptés sont : paiement à la livraison,
          Mobile Money et carte bancaire via des prestataires sécurisés.</p>
        </Section>
        <Section title="Livraison">
          <p>Les produits sont livrés à l'adresse indiquée lors de la commande, partout en Côte d'Ivoire. Les délais et frais
          sont communiqués lors de la validation de la commande.</p>
        </Section>
        <Section title="Droit de rétractation">
          <p>Le client dispose d'un délai de 7 jours à compter de la réception pour retourner un article. Le produit doit être
          retourné dans son état et emballage d'origine.</p>
        </Section>
        <Section title="Données personnelles">
          <p>Les informations collectées sont utilisées uniquement pour le traitement des commandes et ne sont jamais cédées
          à des tiers. Conformément à la réglementation, vous disposez d'un droit d'accès et de rectification de vos données.</p>
        </Section>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="font-display text-2xl text-[#0A0A0A] mb-3">{title}</h2>
      <div className="space-y-2">{children}</div>
    </div>
  );
}
